import { t } from "../i18n"

export interface ConstructionNavItem {
  to: string
  label: string
  testId: string
}

/**
 * ConstructionWalk sidebar items.
 * Admin with no company: Dashboard + Companies.
 * Company selected: Job Sites, Employees, Admin mode, Time clock (plus Companies for admins).
 * Job codes are added only from a job site's cost-code panel, not from nav.
 */
export function getConstructionWalkNav(options: {
  isAdmin: boolean
  hasSelectedCompany: boolean
}): ConstructionNavItem[] {
  const items: ConstructionNavItem[] = [
    { to: "/app", label: t("nav.dashboard"), testId: "nav-dashboard" },
  ]

  if (options.isAdmin) {
    items.push({
      to: "/app/management-companies",
      label: t("nav.companies"),
      testId: "nav-companies",
    })
  }

  if (options.hasSelectedCompany) {
    items.push(
      { to: "/app/locations", label: t("nav.jobSites"), testId: "nav-job-sites" },
      { to: "/app/employees", label: t("nav.employees"), testId: "nav-employees" },
      { to: "/app/admin-mode", label: t("nav.adminMode"), testId: "nav-admin-mode" },
      { to: "/app/time-clock", label: t("nav.timeClock"), testId: "nav-time-clock" },
    )
  }

  return items
}
